import {
  FilterMode,
  UserNotificationPreferenceCreateMutationVariables,
  UserNotificationPreference_OrderBy,
  UserNotificationPreference,
  SortOrder,
  UserNotificationPreference_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const userNotificationPreferenceService = {
  createOne: buildCreateOne(
    (
        userNotificationPreferenceCreateVariables: UserNotificationPreferenceCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.userNotificationPreferenceCreate(
          userNotificationPreferenceCreateVariables
        );
        return result.userNotificationPreferenceCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.userNotificationPreferenceOne({ id });
    return result.userNotificationPreferenceOne as UserNotificationPreference;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: UserNotificationPreference_OrderBy[] | null = null,
    filter: UserNotificationPreference_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: UserNotificationPreference_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.userNotificationPreferenceListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.userNotificationPreferenceListWithOffset
    ) as UserNotificationPreference[];
    return { list, orderBy };
  },
};
